import constants from 'constants/index'
import helpers from 'helpers'

const getStepId = (step, trailSteps) => {
  const {
    STEP_VISUAL_IDENTITY,
    STEP_SITE,
    STEP_COOKIE,
    STEP_DPO_APPOINTMENT,
    STEP_DOCS,
    STEP_CONCLUSION,
    VISUAL_IDENTITY_TAG,
    COMPANY_SITE_TAG,
    COOKIE_BANNER_TAG,
    DPO_APPOINTMENT_TAG,
    COMPANY_DOCUMENTS_TAG,
    CONCLUSION_TAG,
  } = constants.userTrailSteps

  switch (step) {
    case STEP_VISUAL_IDENTITY:
      return helpers.userTrailSteps.getTrailIdByTag(
        VISUAL_IDENTITY_TAG,
        trailSteps,
      )
    case STEP_SITE:
      return helpers.userTrailSteps.getTrailIdByTag(
        COMPANY_SITE_TAG,
        trailSteps,
      )
    case STEP_COOKIE:
      return helpers.userTrailSteps.getTrailIdByTag(
        COOKIE_BANNER_TAG,
        trailSteps,
      )
    case STEP_DPO_APPOINTMENT:
      return helpers.userTrailSteps.getTrailIdByTag(
        DPO_APPOINTMENT_TAG,
        trailSteps,
      )
    case STEP_DOCS:
      return helpers.userTrailSteps.getTrailIdByTag(
        COMPANY_DOCUMENTS_TAG,
        trailSteps,
      )
    case STEP_CONCLUSION:
      return helpers.userTrailSteps.getTrailIdByTag(CONCLUSION_TAG, trailSteps)
    default:
      return null
  }
}

export default getStepId
